// extracted by mini-css-extract-plugin
module.exports = {"root":"Version_root__5da_c","old":"Version_old__hS12b","new":"Version_new__2HrK1"};